"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapPositionUtils = require("../util/mapPositionUtils");

var _PropertyDot = require("./PropertyDot");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/PropertyMarkers/PropertyLabel.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var splitLabel = function splitLabel(label) {
  if (label && label.indexOf('\t')) {
    return label.split('\t');
  }

  return [];
};

var LABEL_HEIGHT = 14;

function divPerLabel(className, labels, forwardProps) {
  var ret = [];

  for (var i = 0; i < labels.length; ++i) {
    if (forwardProps) {
      var divProps = _objectSpread({}, forwardProps);

      divProps.style = _objectSpread({}, divProps.style, {
        top: i * LABEL_HEIGHT + "px"
      });
      ret.push(_react.default.createElement("div", _extends({}, divProps, {
        key: "label_" + i,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28
        },
        __self: this
      }), labels[i]));
    } else {
      ret.push(_react.default.createElement("div", {
        className: className,
        style: {
          top: i * LABEL_HEIGHT + "px"
        },
        key: "label_" + i,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: this
      }, labels[i]));
    }
  }

  return ret;
}

var PropertyLabel =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(PropertyLabel, _PureComponent);

  function PropertyLabel() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = PropertyLabel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        markerLabel = _this$props.markerLabel,
        labelClassNames = _this$props.labelClassNames,
        show3DHomeLabel = _this$props.show3DHomeLabel,
        showForYouLabel = _this$props.showForYouLabel,
        showDot = _this$props.showDot,
        statusType = _this$props.statusType,
        isRMX3rdPartyTrial = _this$props.isRMX3rdPartyTrial;
    var labels = splitLabel(markerLabel);
    var className = "" + labelClassNames;
    var label3DTour = isRMX3rdPartyTrial ? "3D TOUR" : "3D HOME";

    if (labels.length > 0) {
      if (showDot) {
        var renderedLabels = divPerLabel(className, labels, null);

        if (show3DHomeLabel || showForYouLabel) {
          renderedLabels.push(_react.default.createElement("div", {
            className: "badge-label",
            style: {
              top: (labels.length + 1) * LABEL_HEIGHT - 2 + "px",
              backgroundColor: _PropertyDot.STATUS_ICON_MAP[statusType]
            },
            __source: {
              fileName: _jsxFileName,
              lineNumber: 66
            },
            __self: this
          }, showForYouLabel ? "FOR YOU" : label3DTour));
        }

        return _react.default.createElement(_react.Fragment, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75
          },
          __self: this
        }, renderedLabels);
      }

      var forwardProps = (0, _mapPositionUtils.getForwardableProperties)(this.props);
      forwardProps.className = className + " " + forwardProps.className;
      return _react.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        },
        __self: this
      }, divPerLabel(className, labels, forwardProps));
    }

    return null;
  };

  return PropertyLabel;
}(_react.PureComponent);

PropertyLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  markerLabel: _propTypes.default.string,
  labelClassNames: _propTypes.default.string,
  showDot: _propTypes.default.bool,
  show3DHomeLabel: _propTypes.default.bool,
  showForYouLabel: _propTypes.default.bool,
  statusType: _propTypes.default.string,
  isRMX3rdPartyTrial: _propTypes.default.bool
} : {};
PropertyLabel.defaultProps = {
  markerLabel: '',
  labelClassNames: '',
  showDot: true,
  show3DHomeLabel: false,
  showForYouLabel: false,
  statusType: '',
  isRMX3rdPartyTrial: false
};
var _default = PropertyLabel;
exports.default = _default;